<template>
    <span>
        <v-select v-if="showEditor" valueKey='id' textKey="full_name" :allowUnset="true" display="pending" :options="options" :currentValue="currentValue" @blur="blur" @change="change" ref="el"></v-select>
        <span v-else @click="toggleEdit()">
            <user :user="currentValue" :modified="modified" :mode="mode"/>
        </span>
    </span>
</template>

<script>
    import User from './User.vue'

    export default {
        data () {
            return {
                newValue: '',
                user_set: false,
                pending: false,
                editing: false
            }
        },
        components: {
            'user': User
        },
        created () {
            if(Object.prototype.toString.call(this.currentValue) === '[object Object]') {
                this.newValue = this.currentValue
            }
            else {
                this.newValue = this.options.find(obj => obj.id == this.currentValue);
            }
        },
        updated() {
            if(this.showEditor) {
                this.$refs.el.focus();
            }
        },
        props: {
            options: Array,
            currentValue: null,
            defaultSelection: null,
            mode: null
        },
        computed: {
            modified () {
                return (this.currentValue && this.newValue) && (this.currentValue.id !== this.newValue.id)
            },
            showEditor () {
                return this.editing || !this.newValue || !this.newValue.id;
            },
        },
        watch: {
            currentValue () {
                if (!this.user_set) {
                    this.newValue = this.currentValue
                }
            }
        },
        methods: {
            toggleEdit () {
                this.editing = true
            },
            change ($event) {
                this.editing = false
                this.newValue = $event
                this.$emit('change', $event)
            },
            blur () {
                this.editing = false
            }
        }
    }
</script>